module.exports = __webpack_public_path__ + "static/img/img_cabinet.0ee6a22f.png";